<template>
    <BaseCard>
        <la-fee-table v-if="fees" :data="fees.feetimelines"></la-fee-table>
    </BaseCard>
</template>

<script>
import BaseCard from "@/components/BaseCard";
import LaFeeTable from "@/components/fees/FeeTable";

export default {
    name: "FeeCard",
    components: {
        BaseCard,
        LaFeeTable,
    },
    props: {
        fees: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped></style>
